<template>
    <div v-if="show">
            <v-col>
                <HeaderCheckList
                    title="Bombas"
                    :click="() => create()"
                />
            </v-col>
            <v-row>
                <div v-for="bombItem, i in list">
                    <CardCheckList
                        :loading="loadingIndex === i"
                        :view="() => edit(i)"
                        :remove="() => remove(i)"
                    >
                        <template v-slot:content>
                            <div style="
                                padding: 10px;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                            ">
                                <div>
                                    <h3 style="
                                        font-size: 15px;
                                        color: black;
                                        text-align: center;
                                    ">{{ bombItem.locale }}</h3>
                                </div>
                                <div>
                                    <h4 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ bombItem.reservoir }} / {{ bombItem.watt }} W</h4>
                                </div>
                                <div>
                                    <h5 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ bombItem.hour_day_use }} H/Dia / {{ bombItem.value_kwh }} kWH</h5>
                                </div>
                            </div>
                        </template>
                    </CardCheckList>
                </div>
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Bomba</span></v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-form   
                            ref="bombForm"
                            v-model="isValidForm"
                            lazy-validation
                        >
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="bomb.locale" 
                                        outlined 
                                        label="Local" 
                                        type="text" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-select 
                                        v-model="bomb.reservoir"
                                        outlined 
                                        label="Reservatorio" 
                                        :items="optionsBomb"
                                        prepend-inner-icon="mdi-cup-water" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        outlined 
                                        label="Potênca" 
                                        prefix="W" 
                                        type="Number" 
                                        v-model="bomb.watt"
                                        prepend-inner-icon="mdi-lightning-bolt-outline" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="bomb.hour_day_use" 
                                        outlined 
                                        label="Horas Uso/Dia" 
                                        type="Number"
                                        prepend-inner-icon="mdi-clock-time-five-outline" 
                                        required 
                                        :rules="rulesNumber"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="bomb.value_kwh" 
                                        outlined 
                                        label="Valor do Kw/h" 
                                        prefix="R$ " 
                                        type="Number" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="12" :sm="12">
                                      <v-textarea 
                                        v-model="bomb.comments" 
                                        outlined 
                                        label="Observação" 
                                        type="text"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row dense class="mt-2">
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput"
                                    title="Foto 1"
                                    :refInput="refInput"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="bomb.file_photo"
                                    @change:file="(file) => handleImageChange(file, 1)"
                                />
                            </v-col>
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput + 1"
                                    title="Foto 2"
                                    :refInput="refInput + 1"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="bomb.file_photo2"
                                    @change:file="(file) => handleImageChange(file, 2)"
                                />
                            </v-col>
                        </v-row>
                        <!-- <InputImg v-on:rawFiles="rawFiles = $event"/> -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDialog()">
                        Cancelar
                        </v-btn>
                        <v-btn :disabled="!isValidForm" color="blue darken-1" text @click="save()"> Adicionar </v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
    </div>
</template>
  
<script>
import HeaderCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/HeaderCheckList.vue"
import CardCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/CardCheckList.vue"
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import InputFiles from "@/components/Forms/Input/input-files.vue";
import cloneDeep from 'lodash/cloneDeep';


import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';

const newBomb = () => {
    return {
        hour_day_use: "",
        value_kwh: "",
        locale: "",
        file_photo: null,
        path_photo: null,
        file_photo2: null,
        path_photo2: null,
        watt: "",
        reservoir: "",
        comments: "",
    }
}

export default {
    name: "HydrometerList",
    
    components: {
        HeaderCheckList,
        CardCheckList,
        InputFiles
    },
    
    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
    },
    
    data: () => ({
        loadingIndex: -1,
        isValidForm: false,
        refInput: new Date().getTime(),
        dialog: false,
        index: -1,
        bomb: newBomb(),
        optionsBomb: ["Poço", "Recalque"],
    }),

    computed: {
        rulesRequired() {
            return Rules.required();
        },
        rulesNumber() {
            return Rules.number(true, 0, 24);
        },
    },

    methods: {
        create() {
            this.index = -1
            this.bomb = newBomb()
            this.refInput = new Date().getTime()
            this.dialog = true
        },
        handleImageChange(file, photoNumber) {
            const fileKey = photoNumber === 1 ? 'file_photo' : 'file_photo2';
            const pathKey = photoNumber === 1 ? 'path_photo' : 'path_photo2';

            if (this.bomb[fileKey] === file) return;

            if (!file) {
                this.$set(this.bomb, pathKey, null);
                this.$set(this.bomb, fileKey, null);
            } else {
                this.$set(this.bomb, pathKey, null);
                this.$set(this.bomb, fileKey, file);
            }
        },
        clearImageState() {
            if (this.bomb) {
                this.bomb.file_photo = null
                this.bomb.path_photo = null
                this.bomb.file_photo2 = null
                this.bomb.path_photo2 = null
            }
        },
        async edit(index) {
            try {
                this.loadingIndex = index;
                this.index = index
                this.bomb = cloneDeep(this.list[index])

                if (!this.bomb.hasOwnProperty('file_photo')) this.$set(this.bomb, 'file_photo', null)
                if (!this.bomb.hasOwnProperty('file_photo2')) this.$set(this.bomb, 'file_photo2', null)

                this.refInput = new Date().getTime()

                if (this.bomb.path_photo) {
                    try {
                        const file1 = await DiagnosticStorage.downloadImg(this.bomb.path_photo)
                        this.$set(this.bomb, 'file_photo', file1)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 1:', error)
                        this.$set(this.bomb, 'file_photo', null)
                    }
                }

                if (this.bomb.path_photo2) {
                    try {
                        const file2 = await DiagnosticStorage.downloadImg(this.bomb.path_photo2)
                        this.$set(this.bomb, 'file_photo2', file2)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 2:', error)
                        this.$set(this.bomb, 'file_photo2', null)
                    }
                }

                await this.$nextTick()
                this.dialog = true
            } finally {
                this.loadingIndex = -1;
            }
        },
        save() {
            if (!this.$refs.bombForm.validate()) return
            this.add(cloneDeep(this.bomb), this.index)
            this.dialog = false
            this.clearImageState()
        },
        closeDialog() {
            this.dialog = false
            this.clearImageState()
            if (this.bomb) {
                this.bomb.file_photo = null
                this.bomb.file_photo2 = null
            }
        },
    },

    watch: {
        
    },

};
</script>
  
<style scoped>

</style>
